export default __webpack_public_path__ + "static/media/deliveries_8.2e956210.png";